export default "__VITE_ASSET__9936b4cf__"